import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const api = axios.create({ baseURL: API, withCredentials: true });

export const tokens = {
  set(a, r) { localStorage.setItem("kfh_access", a); if (r) localStorage.setItem("kfh_refresh", r); },
  clear() { localStorage.removeItem("kfh_access"); localStorage.removeItem("kfh_refresh"); },
};

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("kfh_access");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use((r) => r, async (err) => {
  const orig = err.config || {};
  const skip = ["/auth/login", "/auth/refresh"].some((p) => (orig.url || "").includes(p));
  if (err.response?.status === 401 && !orig._retry && !skip) {
    orig._retry = true;
    const rt = localStorage.getItem("kfh_refresh");
    if (rt) {
      try {
        refreshing = refreshing || axios.post(`${API}/auth/refresh`, { refresh_token: rt });
        const { data } = await refreshing;
        tokens.set(data.access_token, data.refresh_token);
        refreshing = null;
        return api(orig);
      } catch {
        refreshing = null;
        tokens.clear();
      }
    }
  }
  return Promise.reject(err);
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export async function downloadFile(url, filename) {
  const { data } = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}

export const money = (v, cur = "INR") =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: cur || "INR" }).format(v || 0);

export const fmtDate = (iso) => {
  if (!iso) return "-";
  const dateOnly = typeof iso === "string" && /^\d{4}-\d{2}-\d{2}$/.test(iso);
  const date = new Date(dateOnly ? `${iso}T12:00:00` : iso);
  return date.toLocaleDateString(undefined, { weekday: "short", day: "2-digit", month: "short", year: "numeric" });
};

export const TIMEZONES = (() => {
  try { return Intl.supportedValuesOf("timeZone"); } catch { return ["UTC", "Asia/Kolkata", "Europe/London", "America/New_York"]; }
})();

export default api;
